import { applyModelIdPrefixV820 } from './channelModelVisibilityV820';
import { applyDiscoveredModelImportV93 } from './channelModelDiscoveryV93';
import { modelSyncConfigV103 } from './modelSyncConfigV103';

export function upstreamModelV1018(publicModel, mapping = {}, prefix = '') {
  const normalized = String(prefix)
    .trim()
    .replace(/^-+|-+$/g, '');
  const strip = (value) =>
    normalized && value.startsWith(`${normalized}-`)
      ? value.slice(normalized.length + 1)
      : value;
  return Object.prototype.hasOwnProperty.call(mapping, publicModel)
    ? mapping[publicModel]
    : strip(publicModel);
}

export function importChannelModelsV1018(
  current,
  rawModels,
  source,
  config,
  prefix,
  mapping = {},
  append = false
) {
  const policy = modelSyncConfigV103(config);
  const discovered = rawModels.map((id) => applyModelIdPrefixV820(id, prefix));
  if (
    !policy.add_all_new &&
    policy.provider !== 'nvidia' &&
    !policy.strip_free_suffix
  ) {
    return append
      ? Array.from(new Set([...current, ...discovered]))
      : applyDiscoveredModelImportV93(current, discovered, source);
  }
  const represented = new Set(
    current.map((id) => upstreamModelV1018(id, mapping, prefix))
  );
  const models = [...current];
  rawModels.forEach((id, index) => {
    if (represented.has(id)) return;
    if (
      models.some(
        (name) => name.toLowerCase() === discovered[index].toLowerCase()
      ) ||
      Object.keys(mapping).some(
        (name) => name.toLowerCase() === discovered[index].toLowerCase()
      )
    ) {
      const error = new Error('model_sync_v103.manual_alias_conflict');
      error.model = discovered[index];
      throw error;
    }
    if (
      !represented.has(id) &&
      !models.includes(discovered[index]) &&
      !Object.prototype.hasOwnProperty.call(mapping, discovered[index])
    ) {
      models.push(discovered[index]);
      represented.add(id);
    }
  });
  // The server applies aliases and rejects collisions atomically on save.
  return models;
}
